import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";

@Injectable()
export class CluPuSnackbarService {

  constructor(private _snackbar : MatSnackBar) { }

  private panelClass : string;
  private errorMessage : string;
  private alert: { type: string; action: string; message: string } = { type   : 'success', action : 'SUCCES', message: '' };
  public displayMessage(_type : string, _message : string){
      switch(_type){
          case "SUCCESS" : this.alert.type = 'success'; this.alert.action = 'SUCCES'; this.panelClass = 'ccsuccess-snackbar'; this.errorMessage = _message; break;
          case "ERROR" : this.alert.type = 'error'; this.alert.action = 'ERREUR'; this.panelClass = 'ccerror-snackbar'; this.errorMessage = _message; break;
          case "INFO" : this.alert.type = 'info'; this.alert.action = 'INFO'; this.panelClass = 'ccinfo-snackbar'; this.errorMessage = _message; break;
          case "WARN" : this.alert.type = 'warn'; this.alert.action = 'ATTENTION'; this.panelClass = 'ccwarn-snackbar'; this.errorMessage = _message; break;
      }
      this._snackbar.open(this.errorMessage, this.alert.action, { duration : 10000, panelClass : [this.panelClass] });
  }
}
